 <app-table-title [introText]="introText" [title]="'FORMS' | dictionary"></app-table-title>
 <!-- <div class="row">
   <div class="col-lg-12">
     <div class="m-portlet m-portlet--unair" style="margin-bottom: 0;">
       <div class="pr-2 home-middle-header-bgcolor" style="display: flex;padding-top: 1px;padding-bottom: 1px;">
         <div class="form-row col-lg-12 pt-2 pb-2">

           <div class="col-md-6 col-sm-12 filter-wrapper">
             <label class="text-right text-color-1 filter-label">{{"FUND" | dictionary}}</label>
             <div style="padding: 0;width: calc(100% - 100px);">
               <select class="form-control" [(ngModel)]="fund" (ngModelChange)="search()">
                 <option *ngFor="let fund of funds" [value]="fund.FundId">{{fund.Title}}</option>
               </select>
             </div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>  -->
 <div class="row table-container">
   <div class="col-lg-12 table-container">
     <kendo-grid #kendoGridComponent [data]="forms" [loading]="loading"
                 [navigable]="true" [sortable]="{allowUnsort: false, mode: 'single'}" [sort]="sort"
                 (sortChange)="sortChange($event)">
       <kendo-grid-column [headerClass]="'gridheader  text-color-1'" field="Label" title="{{'FORM' | dictionary}}">
       </kendo-grid-column>


       <kendo-grid-column [headerClass]="'gridheader text-color-1'" field="Form" title="{{'DOWNLOAD' | dictionary}}" [width]="110" [sortable]="false">
         <ng-template kendoGridCellTemplate let-dataItem>
           <div class="download-icon" (click)="openDocument(dataItem.seqNum, dataItem.FileNum)">
             <i class="fas fa-file-download icon"></i>
           </div>
         </ng-template>
       </kendo-grid-column>

     </kendo-grid>
   </div>
 </div>

 <app-pop-up-dialog [Message]="alertMessage" [Display]="display" (DisplayBack)="onConfirm()">
 </app-pop-up-dialog>

